import { isTokenExpired } from './jwt';
// Utilitário para limpar dados de autenticação
export const clearAuthData = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('refresh_token');
    console.log('✅ Dados de autenticação limpos. Faça login novamente.');
};
// Verificar se há dados antigos/inválidos e limpar se necessário
export const checkAndClearOldAuth = () => {
    const userStr = localStorage.getItem('user');
    const token = localStorage.getItem('auth_token');
    // Se não há dados, não precisa limpar
    if (!userStr && !token) {
        return false;
    }
    // Verificar se o token está expirado
    if (token && isTokenExpired(token)) {
        console.log('🔄 Token expirado. Limpando dados de autenticação...');
        clearAuthData();
        return true;
    }
    // Verificar se os dados do usuário estão válidos
    if (userStr) {
        try {
            const user = JSON.parse(userStr);
            // Se o usuário não tem propriedades essenciais, é um dado antigo/inválido
            if (!user.id || !user.email) {
                console.log('🔄 Detectados dados de usuário inválidos. Limpando...');
                clearAuthData();
                return true;
            }
        }
        catch (error) {
            console.log('🔄 Dados de usuário corrompidos. Limpando...');
            clearAuthData();
            return true;
        }
    }
    return false;
};
